import { DEFAULT_LANGUAGE } from 'tradera-lang/constants.mjs';

export const selectAvailableLanguages = state => state.language.available;

export const selectAvailableLanguageCodesIso2 = state =>
    state.language.available.map(x => x.languageCodeIso2);

export const selectPreferredLanguage = state => state.language.preferred;

export const selectPreferredLanguageCode = state =>
    state.language.preferred?.languageCodeIso2 || DEFAULT_LANGUAGE;

export const selectLocale = state => {
    const language = selectPreferredLanguageCode(state);
    const country = state.language.memberCountryCodeIso2 || 'SE';

    return `${language}-${country}`;
};

export const selectIsForeignLanguageActivated = state =>
    selectPreferredLanguage(state).languageCodeIso2 !== DEFAULT_LANGUAGE;

export const selectAutomaticTranslationPreference = state =>
    state.language.automaticTranslationPreference;
